// extracted by mini-css-extract-plugin
export default {"wrapper":"myProjects_wrapper__b7nG8","tabs":"myProjects_tabs__kMiTJ","list":"myProjects_list__3gLB8"};